/**
 * ============================================================================
 * Traceability 模块 API 路由定义
 * ============================================================================
 * 
 * @module api/traceability/routes
 * @generated Manual (AI-assisted)
 * @last-updated 2025-11-28
 * ============================================================================
 */

import { API_V1_ROUTES } from '../routes/v1'

export const API_ROUTES = {
  traceability: {
    /** 快速查询 GET /api/v1/trace/query */
    query: API_V1_ROUTES.trace.query,
    
    /** 正向追溯 GET /api/v1/trace/material/{materialBatchNo} */
    forward: API_V1_ROUTES.trace.forward,
    
    /** 反向追溯 GET /api/v1/trace/batch/{batchNo} */
    backward: API_V1_ROUTES.trace.backward,
    
    /** 全链路追溯 GET /api/v1/trace/full/{batchNo} */
    full: API_V1_ROUTES.trace.full,
    
    /** 生命周期追溯 GET /api/v1/trace/lifecycle/{batchNo} */
    lifecycle: API_V1_ROUTES.trace.lifecycle,
  },
} as const
